import React, { useRef, useState } from 'react';

import { Select } from '@aline/common';
import { ButtonBase } from '@mui/material';
import { useClickAway } from 'react-use';
import { useIntercom } from 'react-use-intercom';
import { useLeftNavItemStyles } from 'src/components';
import { ChatHelpIcon } from 'src/components/icons/ChatHelpIcon';

import { NavItemText } from './nav/left-nav/NavItemText';

export function ContactSupport(): JSX.Element {
  const { show } = useIntercom();
  const ref = useRef<HTMLButtonElement>(null);
  const [isActive, setIsActive] = useState<boolean>(false);
  const { classes: navItemClasses } = useLeftNavItemStyles({ selected: isActive });

  useClickAway(ref, () => setIsActive(false));

  return (
    <ButtonBase
      ref={ref}
      className={navItemClasses.content}
      data-cy={Select.topNav.supportButton}
      onClick={() => {
        setIsActive(true);
        show();
      }}
    >
      <ChatHelpIcon />
      <NavItemText>Support</NavItemText>
    </ButtonBase>
  );
}
